import { useQuery } from '@tanstack/react-query'
import { useCustomerContext } from './CustomerProvider'
import {
  getCustomerUsersQuery,
  getExtranetRolesQuery,
  getMyCustomerUserRolesQuery,
  getUserCustomerQuery,
  getUserCustomersQuery,
} from './customership.queries'

export const useUserCustomerDetails = () => {
  const { customer, roles } = useCustomerContext()

  const { data: userCustomer, isLoading: isLoadingUserCustomer } = useQuery(
    getUserCustomerQuery(customer?.id)
  )

  const { data: userCustomers, isLoading: isLoadingUserCustomers } = useQuery(
    getUserCustomersQuery()
  )
  const { data: userCustomerRoles, isLoading: isLoadingUserCustomerRoles } = useQuery(
    getMyCustomerUserRolesQuery(customer?.id)
  )

  const { data: customerUsers } = useQuery({
    ...getCustomerUsersQuery(customer?.id),
    enabled:
      !!userCustomer &&
      !!roles &&
      (roles.isAdmin || !!roles.roles.find((a) => a.role === 'customer-user-management')),
  })

  const { data: allRoles } = useQuery(getExtranetRolesQuery())

  return {
    allRoles,
    customership: customer,
    userCustomer,
    userCustomers,
    customerUsers,
    userCustomerRoles,
    isLoadingUserCustomerRoles,
    isLoadingUserCustomer,
    isLoadingUserCustomers,
  }
}
